export interface IAccountStrings {
    login: {
        buttonBack: string;
        buttonNext: string;
        buttonSignUp: string;
        error: {
            invalidNumber: string;
            default: string;
        };
        forgotPassword: string;
        inputMask: string;
        passwordPlaceholder: string;
        passwordConfirmPlaceholder: string;
        phonePlaceholder: string;
        subtitle: {
            1: string;
            2: string;
        };
        title: string;
    };
    signup: {
        ageToUseCheckbox: string;
        agreeTermsCheckbox: {
            agree: string;
            terms: string;
            feedback: string;
        },
        signup_button: string;
        back_button: string;
        feedback: {
            age: string;
            code: string;
            name: string;
            phone: string;
            email: string;
            password: string;
            passwordConfirm: string;
        },
        inputMask: string;
        password_guide: {
            Week: string;
            Moderate: string;
            Strong: string;
            Strongest: string;
        },
        placeholder: {
            name: string;
            phone: string;
            email: string;
            password: string;
            passwordConfirm: string;
            code: string;
        },
        title: string;
        codeTitle: string;
        resendCodeText: string;
        signupSuccess: string;
        errors: {
            WAIT_TO_RESEND: string;
            SIGNUP_USER_NOT_FOUND: string;
            SIGNUP_PHONE_BLOCKED: string;
            SIGNUP_EMAIL_BLOCKED: string;
            SIGNUP_USER_NOT_CREATED: string;
        }
    };
    recovery: {
        recoveryButton: string;
        requestRecoveryButton: string;
        backButton: string;
        contactInput: {
            placeholder: string;
        };
        title: string;
        description: string;
        errors: {
            RECOVERY_SUCCESS: string;
            RECOVERY_WRONG_DATA: string;
            RECOVERY_CODE_EXPIRED: string;
            DATA_NOT_PROVIDED: string;
            PASSWORD_UNAVAILABLE: string;
            SIGNUP_PHONE_BLOCKED: string;
        };
        inputMask: string;
    };
}

export const AccountStrings: {
    PTBR: IAccountStrings
} = {
    PTBR: {
        login: {
            buttonBack: "Voltar",
            buttonNext: "Avançar",
            buttonSignUp: "Criar conta",
            error: {
                invalidNumber: "Número de telefone inválido",
                default: "Por favor, insira um número de telefone",
            },
            forgotPassword: "Esqueceu a senha?",
            inputMask: "(99) 9-9999-9999",
            passwordPlaceholder: "Digite sua senha",
            phonePlaceholder: "Seu telefone",
            subtitle: {
                1: "Entre com seu telefone para fazer login",
                2: "Digite a sua senha",
            },
            title: "Entrar",
            passwordConfirmPlaceholder: ""
        },
        signup: {
            ageToUseCheckbox: 'Afirmo que tenho 18 anos ou mais e sou o único responsável pelos meus dados de acesso',
            agreeTermsCheckbox: {
                agree: 'Concordo e aceito os ',
                terms: 'Termos de Uso e Política de Privacidade',
                feedback: 'Você precisa aceitar antes de continuar',
            },
            signup_button: "Criar conta",
            back_button: "Voltar",
            feedback: {
                age: "Você precisa confirmar sua maioridade",
                code: "Informe o código enviado para seu número de telefone",
                email: "Informe um e-mail válido",
                name: "Este não é um nome válido",
                phone: "Número de telefone inválido",
                password: "Sua senha não atende os requisitos",
                passwordConfirm: "A confirmação da senha precisa ser igual à senha",
            },
            inputMask: "(99) 9-9999-9999",
            password_guide: {
                Week: "Sua senha precisa ter no mínimo 6 dígitos",
                Moderate: "Sua senha precisa ter:<ul><li>8 caracteres</li><li>1 número</li><li>letra maiúscula</li><li>letra minúsculas</li></ul>",
                Strong: "Sua senha precisa ter:<ul><li>8 caracteres</li><li>1 número</li><li>letra maiúscula</li><li>letra minúscula</li><li>1 caractere especial !@#$%</li><li>Não pode conter dados pessoais</li></ul>",
                Strongest: "Sua senha precisa ter</li><li>12 caracteres</li><li>1 número</li><li>1 letra maiúscula</li><li>1 letra minúscula</li><li>1 caractere especial !@#$%</li><li>Não pode conter dados pessoais</li></ul>",
            },
            placeholder: {
                code: "Ex.: 1 A 2 B 3",
                email: "Seu e-mail",
                password: "Digite sua senha",
                passwordConfirm: "Repita sua senha",
                phone: "Seu telefone",
                name: "Seu nome completo",
            },
            title: "Cadastre-se",
            codeTitle: "Informe o código recebido por SMS em seu telefone",
            resendCodeText: "Reenviar o código",
            signupSuccess: "Tudo certo, agora faça seu login.",
            errors: {
                WAIT_TO_RESEND: "Aguarde 2 minutos para reenviar o código",
                SIGNUP_USER_NOT_FOUND: "Algo deu errado, tenta se cadastrar novamente",
                SIGNUP_PHONE_BLOCKED: "Este telefone ou e-mail não pode ser utilizado",
                SIGNUP_EMAIL_BLOCKED: "Este telefone ou e-mail não pode ser utilizado",
                SIGNUP_USER_NOT_CREATED: "Não conseguimos te cadastrar neste momento. Tente novamente."
            }
        },
        recovery: {
            backButton: "Voltar",
            contactInput: {
                placeholder: "Informe seu número de telefone ou e-mail"
            },
            description: "Informe seu número de telefone ou e-mail para te enviarmos o código de recuperação",
            errors: {
                RECOVERY_SUCCESS: "Dados enviados com sucesso",
                RECOVERY_WRONG_DATA: "Não conseguimos te localizar por aqui",
                RECOVERY_CODE_EXPIRED: "Este código está expirado, tente recuperar seu acesso novamente",
                DATA_NOT_PROVIDED: "Algum dado importante não foi informado corretamente",
                PASSWORD_UNAVAILABLE: "Esta senha não pode ser utilizada por ser considerada fraca ou você já a utilizou anteriormente",
                SIGNUP_PHONE_BLOCKED: "Este número de telefone não parece estar correto"
            },
            inputMask: "(99) 9-9999-9999",
            recoveryButton: "Enviar",
            requestRecoveryButton: "Recuperar acesso",
            title: "Recuperar Acesso",
        }
    },
};